import {
  validateBankgiroSweden,
  validateOcrSweden,
  validatePlusgiroSweden
} from "@stacc/bank-validation";
import type { RefinanceDebt } from "./types";

// A Swedish account number is valid when it is either a bankgiro or a plusgiro number.
export const isValidAccountNumber = (value: string): boolean =>
  !!value && (validateBankgiroSweden(value) || validatePlusgiroSweden(value));

/**
 * Returns a caseworker-friendly explanation of why an account number is not a valid
 * bankgiro, or an empty string when it is valid.
 */
export const getAccountNumberError = (value: string): string => {
  if (!value?.trim()) {
    return "Bankgiro number is required.";
  }
  if (isValidAccountNumber(value)) {
    return "";
  }
  return "Invalid bankgiro number. Check the digits and try again.";
};

/**
 * Returns an error for an invalid Swedish OCR payment reference, or an empty string when the
 * field is blank (it is optional) or a valid OCR. Mirrors the update-refinance task so the two
 * editors reject the same references.
 */
export const getPaymentReferenceError = (value: string): string => {
  if (!value?.trim()) {
    return "";
  }
  return validateOcrSweden(value)
    ? ""
    : "Invalid payment reference (OCR). Check the digits and try again.";
};

export const typeLabel = (type: RefinanceDebt["type"]): string => {
  if (type === "loan") {
    return "Loan";
  }
  if (type === "card") {
    return "Card";
  }
  return "Debt";
};

export const sourceLabel = (isFromUc: boolean): string =>
  isFromUc ? "From UC credit report" : "Entered manually";
